module.exports = __webpack_public_path__ + "static/media/soils_example_1_2.e5647163.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_example_1_2.png
// module id = 1280
// module chunks = 0